import { useCallback } from 'react';
import { useWorkspace } from '~/contexts';

export default function useProjectSettingsURL() {
  const { workspace } = useWorkspace();

  return useCallback(
    (project, tab, section) =>
      [`/app/${workspace.key}/portfolio/projects/${project.client.key}/${project.key}/settings`, tab, section]
        .filter(Boolean)
        .join('/'),
    [workspace.key],
  );
}
